import React, { useState, useEffect } from 'react';
import { BACKEND_NODE_URL } from '../config/constants';
import './SearchContactModal.css';
import AppIcon from './icons/AppIcon';

export default function SearchContactModal({ isOpen, onClose, projectId, onSelectContact }) {
  const [contacts, setContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    const term = String(searchTerm || '').trim();
    if (!term) {
      setContacts([]);
      setFilteredContacts([]);
      return;
    }
    const timer = setTimeout(() => {
      loadContacts(term);
    }, 300);
    return () => clearTimeout(timer);
  }, [isOpen, projectId, searchTerm]);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredContacts(contacts);
    } else {
      const filtered = contacts.filter(contact => {
        const nome = contact.nome?.toLowerCase() || '';
        const numero = contact.numero?.toLowerCase() || '';
        const email = contact.email?.toLowerCase() || '';
        const search = searchTerm.toLowerCase();
        return nome.includes(search) || numero.includes(search) || email.includes(search);
      });
      setFilteredContacts(filtered);
    }
  }, [searchTerm, contacts]);

  const loadContacts = async (term) => {
    try {
      setLoading(true);
      const user = JSON.parse(localStorage.getItem('astro_user_data') || '{}');
      const params = new URLSearchParams({
        company_id: user.company_id || '',
        user_id: user?.id || '',
        project_id: projectId || '',
        q: term || '',
        limit: '50'
      });
      const authToken = localStorage.getItem('astro_auth_token');
      const response = await fetch(`${BACKEND_NODE_URL.replace(/\/$/, '')}/contacts/project-contacts/search?${params.toString()}`,
        {
          headers: authToken ? { Authorization: `Bearer ${authToken}` } : undefined
        }
      );
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload?.ok) {
        throw new Error(payload?.error || 'Falha ao buscar contatos do projeto');
      }
      setContacts(payload?.data || []);
      setFilteredContacts(payload?.data || []);
    } catch (error) {
      console.error('Erro ao carregar contatos:', error);
      alert('Erro ao carregar contatos: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectContact = (contact) => {
    const user = JSON.parse(localStorage.getItem('astro_user_data') || '{}');
    const normalizedCard = {
      ...contact,
      entity_type: 'contact',
      entity_id: contact.entity_id || contact.id,
      company_id: contact.company_id || user?.company_id || null
    };
    setSelectedContact(normalizedCard);
    onSelectContact(normalizedCard, normalizedCard.list_id);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content search-contact-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Buscar Contato</h2>
          <button className="btn-close" onClick={onClose}>
            <AppIcon name="close" />
          </button>
        </div>

        <div className="modal-body">
          <div className="search-input-container">
            <AppIcon name="search" className="search-icon" />
            <input
              type="text"
              placeholder="Buscar por nome, telefone ou email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
              autoFocus
            />
          </div>

          {loading ? (
            <div className="loading-state">
              <AppIcon name="hourglass_empty" className="spinning" />
              <p>Carregando contatos...</p>
            </div>
          ) : filteredContacts.length === 0 ? (
            <div className="empty-state">
              <AppIcon name="person_off" />
              <p>{searchTerm ? 'Nenhum contato encontrado' : 'Nenhum contato disponível'}</p>
            </div>
          ) : (
            <div className="contacts-list">
              {filteredContacts.map((contact) => (
                <div
                  key={contact.id}
                  className="contact-item"
                  onClick={() => handleSelectContact(contact)}
                >
                  <div className="contact-avatar">
                    <AppIcon name="person" />
                  </div>
                  <div className="contact-info">
                    <div className="contact-name">{contact.nome || 'Sem nome'}</div>
                    <div className="contact-details">
                      {contact.numero && <span className="contact-phone">{contact.numero}</span>}
                      {contact.email && <span className="contact-email">{contact.email}</span>}
                    </div>
                  </div>
                  <div className="contact-action">
                    <AppIcon name="open_in_new" />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
